module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-download-fill-3c87326c.svg";